// news actions
export const FETCH_FIVE_TOURS_REQUEST = 'FETCH_FIVE_TOURS_REQUEST';
export const FETCH_TOURS_REQUEST = 'FETCH_TOURS_REQUEST';

export const FETCH_TOURS_SUCCESS = 'FETCH_TOURS_SUCCESS';
export const FETCH_FIVE_TOURS_FAILURE = 'FETCH_FIVE_TOURS_FAILURE';

export const FETCH_ONETOURS_REQUEST = 'FETCH_ONETOURS_REQUEST';
export const FETCH_ONETOURS_FAILURE = 'FETCH_ONETOURS_FAILURE';

export const CREATE_TOURS_REQUEST = 'CREATE_TOURS_REQUEST';
export const CREATE_TOURS_SUCCESS = 'CREATE_TOURS_SUCCESS';
export const CREATE_TOURS_FAILURE = 'CREATE_TOURS_FAILURE';
export const TOURS_DELETE_SUCCESS = 'TOURS_DELETE_SUCCESS';
export const TOURS_DELETE_FAILULE = 'TOURS_DELETE_FAILULE';
export const TOURS_STATUS_UPDATE_SUCCESS = 'TOURS_STATUS_UPDATE_SUCCESS';
export const TOURS_STATUS_UPDATE_FAILULE = 'TOURS_STATUS_UPDATE_FAILULE';

export const TOURS_UPDATE_SUCCESS = 'TOURS_UPDATE_SUCCESS';
export const TOURS_UPDATE_FAILULE = 'TOURS_UPDATE_FAILULE';

export const UPLOAD_IMAGE = 'UPLOAD_IMAGE';
